import React from 'react';
import { PageTitle } from 'views/common/components';
import { RateRangesComponent } from 'views/VehicleModelView/components/RateRangesComponent';
import Youtube from 'react-lazyload-youtube';
import Typography500 from 'views/common/components/UI/Typography500';
import StyledBox, {
  StyledMainWidgetWrapper,
  StyledDropdownFilter,
  StyledDetailedRating,
  StyledImgBox,
} from 'views/VehicleModelView/components/VehicleModelDetails/VehicleModelDetails.styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { Grid, Box, Typography } from '@mui/material';
import 'react-lazyload-youtube/dist/index.css';
import blur from 'public/imgs/1x1.png';

const VehicleModelDetails = (props) => {
  const {
    breadcrumbsObject,
    vehicleModelName,
    locationName,
    image,
    description,
    youtubeId,
    vehicleModelsList,
    rateRanges,
    handleChangeModelClick,
    vehicleModelLocationId,
    vehicleModelId,
    vehicleModelRatings,
    rentalWidgetInitData,
  } = props;
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  const { t } = useTranslation('fe_er_vehicle_model_page');

  return (
    <StyledBox>
      <Box pt={3} mb={4}>
        <PageTitle
          mainTitleObject={{
            name: t(
              'fe_er_vehicle_model_page:vehicle_model_name_with_location',
              {
                vehicle_model_name: vehicleModelName,
                location_name: locationName,
              },
            ),
          }}
          breadcrumbsObject={breadcrumbsObject}
          shareList={!isCrawler}
        />
      </Box>

      <Grid container>
        <Grid item xs={12} lg={7}>
          <StyledImgBox
            image={image}
            imgWidth="670px"
            imgHeight="384px"
            objectFit="contain"
            className="VMDimg"
            priority
            placeholder="blur"
            blurDataURL={blur.src}
          />
          <Box className="showDESKTOP">
            {rateRanges.length > 0 && (
              <RateRangesComponent rateRanges={rateRanges} />
            )}
          </Box>
          <Box p={2} className="showTABLET">
            <StyledDetailedRating
              rateValue={[
                vehicleModelRatings.rider_comfort,
                vehicleModelRatings.passenger_comfort,
                vehicleModelRatings.luggage_capacity,
              ]}
              ratingComponentProps={{ readOnly: true }}
            />
          </Box>

          <Box textAlign="center">
            <StyledDropdownFilter
              className="VMDfilter"
              filterList={vehicleModelsList}
              handleChange={handleChangeModelClick}
            />
          </Box>
          {description && (
            <Typography
              component="p"
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          )}

          {youtubeId && (
            <>
              <Typography500
                component="h2"
                variant="h4"
                mb={1}
                className="VMsecDark"
                dangerouslySetInnerHTML={{
                  __html: t('fe_er_vehicle_model_page:video_of', {
                    vehicle_model: vehicleModelName,
                  }),
                }}
              />
              <Youtube videoId={youtubeId} width="100%" height="312px" />
            </>
          )}
        </Grid>

        <Grid item xs={12} lg={5} className="showDESKTOP">
          <Box className="VMDwidgetCont">
            <Box textAlign="center" className="VMDadventure">
              <Typography500
                variant="h4"
                component="p"
                pb={2}
                className="VMsecDark">
                {t('fe_er_vehicle_model_page:start_adventure')}
              </Typography500>
              <Typography variant="body2" component="p" pb={3}>
                {vehicleModelName}
              </Typography>
            </Box>

            <Box p={2} className="VMDrating" justifyContent="center">
              <StyledDetailedRating
                rateValue={[
                  vehicleModelRatings.rider_comfort,
                  vehicleModelRatings.passenger_comfort,
                  vehicleModelRatings.luggage_capacity,
                ]}
                ratingComponentProps={{ readOnly: true }}
              />
            </Box>

            <Box p={2}>
              <StyledMainWidgetWrapper
                vertical
                reservationData={{
                  pickup_location_id: vehicleModelLocationId,
                  dropoff_location_id: vehicleModelLocationId,
                  vehicle_model_id: vehicleModelId,
                }}
                reInitWidget={vehicleModelId}
                rentalWidgetInitData={rentalWidgetInitData}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
export { VehicleModelDetails };
